import { render } from "./SortMarketplace.vue?vue&type=template&id=5b7cd948&scoped=true"
import script from "./SortMarketplace.vue?vue&type=script&lang=js"
export * from "./SortMarketplace.vue?vue&type=script&lang=js"

import "@/Common/Styles/Sort.scss?vue&type=style&index=0&id=5b7cd948&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7cd948"]])

export default __exports__